import React, { useCallback, useState } from 'react';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Grid,
    CircularProgress
} from '@material-ui/core';
import { DeleteIcon, EditIcon } from '../../../icons';
import ActionIconButton from '../../../components/atom/ActionIconButton';

import TablePager from '../../../components/atom/TablePager';
import { MODAL_TYPE, useModals } from '../../../hooks/useModal';
import { useNotify } from '../../../hooks/useNotify';
import { doSwaggerCall, useSwaggerClient } from '../../../hooks/useSwaggerClient';
import AdminHeader from '../../../components/atom/AdminHeader';
import { useHistory } from 'react-router';

function SourceListPage() {
    const [search, setSearch] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(0);
    const { showModal } = useModals();
    const { notifyError, notifySuccess } = useNotify();
    const history = useHistory();

    const [data, loading, error, setData, reload] = useSwaggerClient('sources', 'listSources', {
        page,
        pageSize,
        search
    });

    const deleteSource = useCallback(
        sourceId => {
            doSwaggerCall('sources', 'deleteSource', { sourceId })
                .then(() => {
                    // we finished, remove user from list
                    notifySuccess('Source deleted!');
                    reload();
                })
                .catch((err) => {
                    console.log(err);
                    notifyError('Cannot delete source!');
                });
        },
        [setData, data, notifyError, notifySuccess]
    );

    if (error) {
        return (
            <Grid container justifyContent="center">
                <h1>{error}</h1>
            </Grid>
        );
    }

    return (
        <Grid container className="bg-white client-table page" alignItems="center" spacing={2}>
            <AdminHeader
                title="Sources"
                search={search}
                onSearch={newSearch => {
                    setPage(0);
                    setSearch(newSearch);
                }}
                createLabel="New source"
                onCreate={() => {
                    history.push('/admin/sources/create');
                }}
            />
            <Grid item container xs={12} justifyContent="center">
                {loading && data?.items.length === 0 ? (
                    <CircularProgress />
                ) : (
                    <Table style={{ backgroundColor: 'white' }} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Chain</TableCell>
                                <TableCell>Company</TableCell>
                                <TableCell>Source group</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data &&
                                data.items &&
                                data.items.map(source => (
                                    <TableRow key={source.id}>
                                        <TableCell>{source.name}</TableCell>
                                        <TableCell>{source.chain}</TableCell>
                                        <TableCell>{source.company}</TableCell>
                                        <TableCell>{source.sourceGroup}</TableCell>
                                        <TableCell style={{ width: 100 }}>
                                            <ActionIconButton
                                                title="Edit"
                                                icon={EditIcon}
                                                to={`/admin/sources/update/${source.id}`}
                                            />
                                            <ActionIconButton
                                                title="Delete"
                                                icon={DeleteIcon}
                                                onClick={() => {
                                                    showModal(MODAL_TYPE.CONFIRMATION, {
                                                        title: `Are you sure you want to remove ${source?.name}?`,
                                                        content: 'This action is irreversible.',
                                                        confirm: () => deleteSource(source.id)
                                                    });
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                )}
                <Grid container justifyContent="flex-end">
                    <TablePager
                        total={data?.total}
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}

export default SourceListPage;
